import React, { useCallback, useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { updateSessionUser } from '../Auth/userSession';
import { myPageMenu } from './myPageMenu';
import { getMyPage } from './myPageApi';
import '../Practice/AIClients/AIClients.css';
import './MyPage.css';

// 마이페이지 공통 레이아웃: 기본 정보를 한 번 조회해 하위 섹션(Outlet)에 context로 넘긴다.
export default function MyPage() {
    const [myPage, setMyPage] = useState(null);
    const [error, setError] = useState('');

    // GET /api/mypage를 호출해 마이페이지 상태를 채운다.
    const load = useCallback(async () => {
        setError('');
        try {
            setMyPage(await getMyPage());
        } catch (loadError) {
            setError(loadError.message);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    // 수정된 user를 화면 상태와 세션 양쪽에 반영한다.
    const updateUser = useCallback(user => {
        setMyPage(previous => ({ ...previous, user }));
        updateSessionUser(user);
    }, []);

    return <div className="ai-clients-page my-page"><div className="ai-clients-wrap">
        <header className="my-page-heading"><div><span className="ai-kicker">GARAM MIND · MY PAGE</span><h1>마이페이지</h1><p>{myPage?.user.name ? `${myPage.user.name}님, ` : ''}내 정보와 활동 기록을 한곳에서 관리하세요.</p></div></header>
        <div className="my-page-layout">
            <nav className="my-page-nav" aria-label="마이페이지 메뉴">
                {myPageMenu.map(group => <div key={group.group} className="my-page-nav-group"><span>{group.group}</span><ul>
                    {group.items.map(item => <li key={item.path}><NavLink to={item.path}>{item.label}{!item.ready && <small>준비 중</small>}</NavLink></li>)}
                </ul></div>)}
            </nav>
            <section className="my-page-content">
                {error ? <div className="my-page-card my-page-placeholder" role="alert"><h3>정보를 불러오지 못했습니다</h3><p>{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div>
                    : myPage ? <Outlet context={{ myPage, updateUser }} />
                    : <p className="my-page-notice" role="status">정보를 불러오고 있습니다.</p>}
            </section>
        </div>
    </div></div>;
}
